import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Backups() {
  const [list, setList] = useState([]);
  const load = () => api.get('/backups').then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const make = async () => {
    if (!window.confirm('Fazer backup agora?')) return;
    try { const r = await api.post('/backup'); alert(r.data.output); load(); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title">
        <h1>Backups</h1>
        <button onClick={make}>Fazer Backup Agora</button>
      </div>
      <table>
        <thead><tr><th>Arquivo</th><th>Tamanho</th><th>Data</th></tr></thead>
        <tbody>
          {list.map(b => (
            <tr key={b.name}>
              <td style={{fontFamily:'JetBrains Mono'}}>{b.name}</td>
              <td>{(b.size/1024/1024).toFixed(2)} MB</td>
              <td>{new Date(b.mtime).toLocaleString('pt-BR')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{marginTop:'1rem', color:'#a1a1aa', fontSize:'.85rem'}}>Backup automático: diário às 02:00.</p>
    </>
  );
}
